import { useContext, useState } from "react";
import SkillMatrixByUserService from "./SkillMatrixByUserService";
import debounce from "lodash/debounce";
import { AppAuthContext } from "../../../../../../core/contexts/AppAuthProvider";

const useSkillMatrixByUser = () => {
  const { authenticatedUser } = useContext(AppAuthContext);
  const department = authenticatedUser?.department;
  const [searchText, setSearchText] = useState("");
  const [userOptions, setUserOptions] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchingUsers, setSearchingUsers] = useState(false);

  const fetchSkills = async (userId) => {
    try {
      setLoading(true);
      const res = await SkillMatrixByUserService.getSkillsByUser(
        userId,
        department
      );
      setSkills(res.data);
    } catch (err) {
      console.error("Failed to fetch skills:", err);
      setSkills([]);
    } finally {
      setLoading(false);
    }
  };

  const updateSkills = async (userId, skillsToUpdate) => {
    try {
      await SkillMatrixByUserService.updateUserSkills(userId, skillsToUpdate);
      await fetchSkills(userId);
    } catch (err) {
      console.error("Failed to update skills:", err);
    }
  };

  const debouncedSearch = debounce(async (text) => {
    setSearchText(text);
    if (!text) return setUserOptions([]);

    setSearchingUsers(true);
    try {
      const results = await SkillMatrixByUserService.searchUsersByName(
        text,
        department
      );
      const options = results.data.map((user) => ({
        label: `${user.fullName}`,

        value: user.id,

        fullUser: user,
      }));

      setUserOptions(options);
    } catch (err) {
      console.error("Error searching users:", err);
    } finally {
      setSearchingUsers(false);
    }
  }, 400);

  return {
    searchText,
    setSearchText,
    userOptions,
    searchingUsers,
    selectedUser,
    setSkills,
    setSelectedUser,
    skills,
    loading,
    fetchSkills,
    updateSkills,
    debouncedSearch,
  };
};

export default useSkillMatrixByUser;
